import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'aid-decision-radio-buttons',
  template: `
    <div class="aid-layout-column aid-layout-gap-16">
      @if (label) {
        <mat-label>
          {{ (label | translate | sentancecase) + '*' }}
        </mat-label>
      }
      <mat-radio-group
        [formControl]="control"
        class="aid-layout-row aid-layout-gap-16"
      >
        @for (option of options; track option) {
          <mat-radio-button [value]="option" data-cy="decision-radio-button">
            {{ getOption(option) | translate | sentancecase }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  `,
  styleUrls: ['./decision-radio-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DecisionRadioButtonsComponent implements OnInit {
  @Input() label?: string;
  @Input({ required: true }) control = new UntypedFormControl();

  options: boolean[] = [true, false];

  constructor() {}

  ngOnInit() {}

  getOption(option: boolean) {
    return option ? 'yes' : 'no';
  }
}
